module.exports = __webpack_public_path__ + "static/img/img011.b07da99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img011.png
// module id = ZYKn
// module chunks = 1